module.exports = __webpack_public_path__ + "img/keyboard_hide.568f9866.svg";